import './App.css';
import {Routes,Route} from 'react-router-dom'
import Navbar from './components/Navbar/Navbar';
// import Main from './components/Logo';
import Logo from './components/Logo';
import Nothing from './components/Nothing/Nothing';
import Movies from './components/Navbar/Movies';
import Shops from './components/Navbar/Shops';
import MovieDetails from './components/Movies/MovieDetails';
import Action from './components/Movies/Action';
import History from './components/Movies/History';
import Comedy from './components/Movies/Comedy';
import Crime from './components/Movies/Crime';
import Documentary from './components/Movies/Documentary';
import Music from './components/Movies/Music';
import Fantasy from './components/Movies/Fantasy';
import Horror from './components/Movies/Horror';
import Footer from './components/Footer/Footer';


function App() {
  
  return (
    <div className="App">
      <div>
        <Navbar />
        
      </div>

      <Routes>
        <Route path='/' element={<Logo />}  />
        <Route path='/nothing' element={<Nothing />} />
        <Route path='/movies' element={<Movies />}>
          <Route index element={<Action/>}/>
          <Route path='action' element={<Action />} />
          <Route path='fantasy' element={<Fantasy />} />
          <Route path='history' element={<History />} />
          <Route path='comedy' element={<Comedy />} />
          <Route path='crime' element={<Crime />} />
          <Route path='documentary' element={<Documentary />} />
          <Route path='horror' element={<Horror/>} />
          <Route path='music' element={<Music/>}/>
        </Route>
        {/* index route means the link you want to show when the parent element is being clicked */}
       <Route path='/movies/:id' element={<MovieDetails/>}/>
        
        <Route path='/shops' element={<Shops/>}/>
       
        
      </Routes>
      <div>
        <Footer/>
      </div>
      
    </div>
  );
}

export default App;
